import { Box, SvgIcon, Tooltip as TooltipRoot } from '@mui/material'

import { FlexBox } from 'components/Box'
import { TextLink } from 'components/Link'
import { Content } from './Content'
import { chooseIcon, chooseIconColor } from './icon'
import { TooltipProps } from './types'
import { prepareCypressKey } from './utils'

export const Tooltip = ({ flexBox = true, ...props }: TooltipProps): JSX.Element => {
  const { children, content, link, placement }: TooltipProps = props

  const { component, dataCy } = chooseIcon(props)

  const IconContainer: JSX.Element = (
    <SvgIcon
      component={component}
      data-cy={dataCy}
      fontSize='small'
      onClick={props.onClick}
      sx={{
        alignSelf: 'center',
        color: theme => chooseIconColor({ props, theme }),
        cursor: props.onClick ? 'pointer' : 'default',
        ml: 1,
      }}
    />
  )

  return content ? (
    <TooltipRoot
      placement={placement === 'auto' ? undefined : (placement ?? 'right-start')}
      title={
        <>
          {<Content content={content} />}
          {link && <TextLink link={link} />}
        </>
      }
    >
      <Box
        component={flexBox ? FlexBox : Box}
        {...(flexBox ? { axis: 'x' } : {})}
        data-cy={`tooltip-${prepareCypressKey(content)}`}
      >
        {children || IconContainer}
      </Box>
    </TooltipRoot>
  ) : (
    <>{children}</>
  )
}
